// Install: npm install react-icons
import React, { useEffect, useState, useRef } from "react";
import logo from "../../assets/logo.png";
import bgVideo from "../../assets/finance-bg.mp4";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "../../components/Footer/Footer";

// React Icons imports
import {
  GiWheat,
  GiSeedling,
  GiFarmer,
  GiCow,
  GiForest,
  GiEarthAmerica,
  GiScythe,
  GiTrowel,
} from "react-icons/gi";
import {
  FaHandshake,
  FaUsers,
  FaFemale,
  FaChild,
  FaHome,
  FaChurch,
} from "react-icons/fa";
import {
  MdSchool,
  MdAgriculture,
  MdAttachMoney,
  MdGavel,
  MdAccountBalance,
  MdEmail,
  MdPhone,
  MdTrendingUp,
  MdSecurity,
} from "react-icons/md";
import {
  IoLeaf,
  IoEarth,
  IoMap,
  IoPerson,
} from "react-icons/io5";
import {
  BsGraphUpArrow,
  BsPeopleFill,
  BsFillStarFill,
} from "react-icons/bs";
import {
  RiPlantFill,
  RiGovernmentFill,
  RiTeamFill,
} from "react-icons/ri";
import {
  TbMicroscope,
} from "react-icons/tb";
import {
  HiOutlineLightBulb,
} from "react-icons/hi";
import { FiMapPin, FiMail } from "react-icons/fi";
import { AiOutlineQuestionCircle } from "react-icons/ai";

/* ============================================================
   GLOBAL STYLES
   ============================================================ */
const GlobalStyles = () => (
  <style>{`
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: 'DM Sans', sans-serif; background: #faf6f0; color: #1a1208; overflow-x: hidden; }
    .syne { font-family: 'Syne', sans-serif; }

    .ripple-span {
      position: absolute; border-radius: 50%; transform: scale(0);
      animation: rippleAnim 650ms linear; background: rgba(255,255,255,0.35);
      pointer-events: none;
    }
    @keyframes rippleAnim { to { transform: scale(4); opacity: 0; } }

    @keyframes loaderSpin { to { transform: rotate(360deg); } }
    .loader-ring {
      width: 52px; height: 52px; border-radius: 50%;
      border: 3px solid rgba(217,119,6,0.2);
      border-top-color: #d97706;
      animation: loaderSpin 0.8s linear infinite;
    }

    @keyframes heroFadeUp   { from { opacity:0; transform:translateY(40px); } to { opacity:1; transform:translateY(0); } }
    @keyframes heroScale    { from { opacity:0; transform:scale(0.85); } to { opacity:1; transform:scale(1); } }
    @keyframes floatY       { 0%,100% { transform:translateY(0); } 50% { transform:translateY(-14px); } }
    @keyframes orbPulse     { 0%,100% { transform:scale(1) translate(0,0); } 33% { transform:scale(1.08) translate(6px,-8px); } 66% { transform:scale(0.94) translate(-4px,6px); } }
    @keyframes countUp      { from { opacity:0; transform:translateY(8px); } to { opacity:1; transform:translateY(0); } }
    @keyframes shine        { 0% { left:-100%; } 100% { left:200%; } }
    @keyframes spin         { to { transform:rotate(360deg); } }
    @keyframes navSlideDown { from { transform:translateY(-100%); opacity:0; } to { transform:translateY(0); opacity:1; } }
    @keyframes pulse        { 0%,100% { opacity:1; } 50% { opacity:0.6; } }
    @keyframes cardIn       { from { opacity:0; transform:translateY(24px) scale(0.97); } to { opacity:1; transform:translateY(0) scale(1); } }
    @keyframes seedGrow     { 0% { transform: scale(0) rotate(-20deg); opacity: 0; } 60% { transform: scale(1.1) rotate(3deg); opacity: 1; } 100% { transform: scale(1) rotate(0deg); opacity: 1; } }
    @keyframes fieldWave    { 0%,100% { transform: skewX(0deg) translateX(0); } 50% { transform: skewX(1deg) translateX(4px); } }
    @keyframes earthSpin    { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
    @keyframes harvest      { 0%,100% { transform: translateY(0) rotate(0deg); } 25% { transform: translateY(-6px) rotate(-3deg); } 75% { transform: translateY(-3px) rotate(3deg); } }

    .hover-lift { transition: transform 0.3s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.3s ease; }
    .hover-lift:hover { transform: translateY(-6px); }

    .gradient-text-amber {
      background: linear-gradient(135deg, #d97706 0%, #f59e0b 50%, #fbbf24 100%);
      -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
    }

    ::-webkit-scrollbar { width: 6px; }
    ::-webkit-scrollbar-track { background: #faf6f0; }
    ::-webkit-scrollbar-thumb { background: #d97706; border-radius: 3px; }

    .noise::after {
      content:''; position:absolute; inset:0; pointer-events:none;
      background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E");
      background-size: 180px; opacity: 0.4;
    }

    .btn { position:relative; overflow:hidden; cursor:pointer; border:none; font-family:'DM Sans',sans-serif; font-weight:500; transition:all 0.25s ease; }
    .btn:active { transform:scale(0.97); }

    .grid-pattern-amber {
      background-image: linear-gradient(rgba(217,119,6,0.05) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(217,119,6,0.05) 1px, transparent 1px);
      background-size: 48px 48px;
    }

    .hex-pattern {
      background-image: url("data:image/svg+xml,%3Csvg width='60' height='52' viewBox='0 0 60 52' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 2L56 17v18L30 50 4 35V17z' stroke='rgba(217,119,6,0.06)' fill='none' stroke-width='1'/%3E%3C/svg%3E");
      background-size: 60px 52px;
    }

    .progress-bar {
      height: 6px; border-radius: 99px; background: rgba(217,119,6,0.12); overflow: hidden; position: relative;
    }
    .progress-fill {
      height: 100%; border-radius: 99px;
      background: linear-gradient(90deg, #d97706, #f59e0b);
      animation: progressFill 1.5s ease forwards;
      transform-origin: left;
    }
    @keyframes progressFill { from { width: 0; } }

    .tag { display:inline-flex; align-items:center; padding:0.25rem 0.65rem; border-radius:99px; font-size:11px; font-weight:600; letter-spacing:0.04em; font-family:'Syne',sans-serif; }

    .timeline-line { position:absolute; left:24px; top:0; bottom:0; width:2px; background:linear-gradient(to bottom, #d97706, rgba(217,119,6,0.1)); }

    @media (min-width: 768px) { .hamburger { display: none !important; } }
    @media (max-width: 767px) { .desktop-links, .desktop-btns { display: none !important; } }
  `}</style>
);

/* ============================================================
   PAGE LOADER
   ============================================================ */
const PageLoader = ({ loading }) => {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    if (!loading) {
      const t = setTimeout(() => setVisible(false), 600);
      return () => clearTimeout(t);
    }
  }, [loading]);
  if (!visible) return null;
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: '#0d0800',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1.25rem',
      transition: 'opacity 0.6s ease',
      opacity: loading ? 1 : 0,
    }}>
      <img src={logo} alt="Logo" style={{ width: 48, height: 48, objectFit: 'contain', animation: 'pulse 1.5s infinite' }} />
      <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, fontFamily: 'DM Sans, sans-serif', letterSpacing: '0.1em' }}>
        TUMAINI LETU
      </p>
    </div>
  );
};

/* ============================================================
   RIPPLE BUTTON
   ============================================================ */
const RippleButton = ({ children, style = {}, className = '', onClick }) => {
  const handleClick = (e) => {
    const btn = e.currentTarget;
    const span = document.createElement('span');
    const sz = Math.max(btn.clientWidth, btn.clientHeight);
    const rect = btn.getBoundingClientRect();
    span.className = 'ripple-span';
    Object.assign(span.style, {
      width: sz + 'px', height: sz + 'px',
      left: e.clientX - rect.left - sz / 2 + 'px',
      top: e.clientY - rect.top - sz / 2 + 'px',
    });
    btn.querySelectorAll('.ripple-span').forEach(s => s.remove());
    btn.appendChild(span);
    onClick && onClick(e);
  };
  return (
    <button className={`btn ${className}`} style={style} onClick={handleClick}>
      {children}
    </button>
  );
};

/* ============================================================
   NAVBAR
   ============================================================ */
const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const links = ['Accueil', 'Environnement', 'Agriculture', 'Nutrition'];

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => {
    const fn = () => { if (window.innerWidth >= 768) setMenuOpen(false); };
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 100,
      transition: 'all 0.4s ease',
      background: scrolled ? 'rgba(250,246,240,0.92)' : 'transparent',
      backdropFilter: scrolled ? 'blur(20px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(217,119,6,0.12)' : '1px solid transparent',
      animation: 'navSlideDown 0.6s ease both',
    }}>
      <div style={{ maxWidth: 1140, margin: '0 auto', padding: '0 1.25rem', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <button onClick={() => window.location.href = '/'} style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', background: 'none', border: 'none', cursor: 'pointer' }}>
          <img src={logo} alt="Logo" style={{ width: 30, height: 30, objectFit: 'contain', animation: 'pulse 1.5s infinite' }} />
          <span className="syne" style={{ fontWeight: 700, fontSize: 17, color: scrolled ? '#1a1208' : '#fff' }}>
            Tumaini Letu
          </span>
        </button>

        <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }} className="desktop-links">
          {links.map(l => (
            <button key={l} onClick={() => { if (l === 'Accueil') window.location.href = '/'; if (l === 'Environnement') window.location.href = '/environnement'; if (l === 'Nutrition') window.location.href = '/nutrition'; }} style={{
              fontSize: 14, fontWeight: l === 'Agriculture' ? 600 : 400,
              color: l === 'Agriculture' ? '#d97706' : (scrolled ? '#3d2c0e' : 'rgba(255,255,255,0.8)'),
              background: 'none', border: 'none', cursor: 'pointer',
              transition: 'color 0.2s', fontFamily: 'DM Sans, sans-serif',
            }}
              onMouseEnter={e => e.target.style.color = '#d97706'}
              onMouseLeave={e => e.target.style.color = l === 'Agriculture' ? '#d97706' : (scrolled ? '#3d2c0e' : 'rgba(255,255,255,0.8)')}
            >{l}</button>
          ))}
        </div>

        <div style={{ display: 'flex', gap: '0.6rem', alignItems: 'center' }}>
          <div style={{ display: 'flex', gap: '0.6rem' }} className="desktop-btns">
            <RippleButton style={{ padding: '0.5rem 1.1rem', borderRadius: 10, background: '#d97706', color: '#fff', fontSize: 13, fontWeight: 500 }}>Se connecter</RippleButton>
            <RippleButton style={{ padding: '0.5rem 1.1rem', borderRadius: 10, background: 'transparent', color: scrolled ? '#d97706' : '#fff', border: `1.5px solid ${scrolled ? '#d97706' : 'rgba(255,255,255,0.5)'}`, fontSize: 13, fontWeight: 500 }}>S'inscrire</RippleButton>
          </div>
          <button onClick={() => setMenuOpen(!menuOpen)} className="hamburger" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '6px', display: 'flex', flexDirection: 'column', gap: 5 }}>
            {[0, 1, 2].map(i => (
              <span key={i} style={{
                display: 'block', width: 22, height: 2,
                background: scrolled ? '#1a1208' : '#fff',
                borderRadius: 2, transition: 'all 0.3s ease',
                transform: menuOpen ? (i === 0 ? 'rotate(45deg) translate(5px,5px)' : i === 2 ? 'rotate(-45deg) translate(5px,-5px)' : 'scaleX(0)') : 'none',
                opacity: menuOpen && i === 1 ? 0 : 1,
              }} />
            ))}
          </button>
        </div>
      </div>

      <div style={{
        overflow: 'hidden', background: 'rgba(250,246,240,0.97)', backdropFilter: 'blur(20px)',
        maxHeight: menuOpen ? 400 : 0, transition: 'max-height 0.4s cubic-bezier(0.4,0,0.2,1)',
        borderTop: menuOpen ? '1px solid rgba(217,119,6,0.1)' : 'none',
      }}>
        <div style={{ padding: '1rem 1.25rem', display: 'flex', flexDirection: 'column', gap: '0.1rem' }}>
          {links.map(l => (
            <a key={l} href="#" onClick={() => setMenuOpen(false)} style={{
              display: 'block', padding: '0.75rem 0',
              borderBottom: '1px solid rgba(217,119,6,0.08)',
              color: l === 'Agriculture' ? '#d97706' : '#3d2c0e',
              textDecoration: 'none', fontSize: 15,
              fontWeight: l === 'Agriculture' ? 600 : 400,
              fontFamily: 'DM Sans, sans-serif',
            }}>{l}</a>
          ))}
          <div style={{ display: 'flex', gap: '0.75rem', paddingTop: '0.75rem' }}>
            <RippleButton style={{ flex: 1, padding: '0.65rem', borderRadius: 10, background: '#d97706', color: '#fff', fontSize: 14, fontWeight: 500 }}>Se connecter</RippleButton>
            <RippleButton style={{ flex: 1, padding: '0.65rem', borderRadius: 10, background: 'transparent', color: '#d97706', border: '1.5px solid #d97706', fontSize: 14, fontWeight: 500 }}>S'inscrire</RippleButton>
          </div>
        </div>
      </div>
    </nav>
  );
};

/* ============================================================
   STAT CARD
   ============================================================ */
const StatCard = ({ label, value, sub, accentColor, Icon, delay }) => (
  <div style={{
    position: 'relative', overflow: 'hidden',
    borderRadius: 20,
    background: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(255,255,255,0.14)',
    backdropFilter: 'blur(20px)',
    padding: '1.4rem 1.5rem',
    cursor: 'default',
    animation: `cardIn 0.7s cubic-bezier(0.34,1.3,0.64,1) ${delay}s both`,
    transition: 'transform 0.3s cubic-bezier(0.34,1.56,0.64,1), border-color 0.3s',
  }}
    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)'; e.currentTarget.style.borderColor = accentColor + '60'; }}
    onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0) scale(1)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.14)'; }}
  >
    <div style={{ position: 'absolute', top: -32, right: -32, width: 100, height: 100, borderRadius: '50%', background: accentColor, opacity: 0.22, filter: 'blur(28px)', pointerEvents: 'none' }} />
    <div style={{ position: 'absolute', top: 14, right: 16, opacity: 0.15 }}>
      <Icon size={32} color="#fff" />
    </div>
    <div style={{ position: 'relative', zIndex: 1 }}>
      <p style={{ fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.45)', marginBottom: '0.65rem', fontFamily: 'Syne, sans-serif' }}>{label}</p>
      <h2 style={{ fontSize: 26, fontWeight: 700, color: '#fff', fontFamily: 'Syne, sans-serif', marginBottom: '0.5rem', animation: `countUp 0.5s ease ${delay + 0.2}s both` }}>{value}</h2>
      <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)' }}>{sub}</p>
    </div>
  </div>
);

/* ============================================================
   HERO SECTION
   ============================================================ */
const Hero = ({ video }) => {
  const videoRef = useRef(null);
  useEffect(() => {
    const fn = () => {
      if (videoRef.current) videoRef.current.style.transform = `scale(${1 + window.scrollY / 5000})`;
    };
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  // const stats = [
  //   { label: 'Agriculteurs formés', value: '2,800+', sub: 'Formations techniques', accentColor: '#d97706', Icon: GiFarmer, delay: 0.5 },
  //   { label: 'Coopératives créées', value: '34', sub: 'Actives dans la région', accentColor: '#16a34a', Icon: FaHandshake, delay: 0.65 },
  //   { label: 'Hectares cultivés', value: '5,200+', sub: 'En agroécologie', accentColor: '#b45309', Icon: GiWheat, delay: 0.8 },
  // ];

  return (
    <header style={{ position: 'relative', minHeight: '100vh', overflow: 'hidden', color: '#fff', display: 'flex', flexDirection: 'column' }}>
      <video ref={videoRef} autoPlay loop muted playsInline style={{
        position: 'absolute', inset: 0, width: '100%', height: '100%',
        objectFit: 'cover', transition: 'transform 0.1s linear',
      }}>
        <source src={video} type="video/mp4" />
      </video>

      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(160deg, rgba(20,10,0,0.94) 0%, rgba(26,14,4,0.80) 50%, rgba(40,20,4,0.78) 100%)' }} />

      {[
        { size: 500, color: '#d97706', top: '-15%', right: '-10%', dur: '12s', opacity: 0.1 },
        { size: 400, color: '#16a34a', bottom: '-10%', left: '-8%', dur: '16s', opacity: 0.07 },
        { size: 280, color: '#f59e0b', top: '30%', left: '15%', dur: '9s', opacity: 0.06 },
      ].map((o, i) => (
        <div key={i} style={{
          position: 'absolute', width: o.size, height: o.size, borderRadius: '50%',
          background: o.color, top: o.top, bottom: o.bottom, left: o.left, right: o.right,
          filter: `blur(${o.size / 2.5}px)`, opacity: o.opacity, pointerEvents: 'none',
          animation: `orbPulse ${o.dur} ease-in-out infinite ${i * 2}s`,
        }} />
      ))}

      <div className="grid-pattern-amber" style={{ position: 'absolute', inset: 0, opacity: 0.5, pointerEvents: 'none' }} />

      <div style={{
        position: 'relative', zIndex: 2,
        flex: 1, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '7rem 1.5rem 3.5rem',
        textAlign: 'center',
      }}>
        {/* Badge */}
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
          padding: '0.4rem 1rem', borderRadius: 99,
          background: 'rgba(217,119,6,0.14)', border: '1px solid rgba(217,119,6,0.35)',
          marginBottom: '1.5rem',
          animation: 'heroFadeUp 0.6s ease 0.1s both',
        }}>
          <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#d97706', display: 'inline-block', animation: 'pulse 2s ease-in-out infinite' }} />
          <span style={{ fontSize: 12, fontWeight: 500, color: 'rgba(251,191,36,0.9)', letterSpacing: '0.1em', fontFamily: 'Syne, sans-serif' }}>
            AGRICULTURE FAMILIALE & SÉCURITÉ ALIMENTAIRE
          </span>
        </div>

        {/* Logo + Title */}
        <div style={{ animation: 'heroFadeUp 0.7s ease 0.2s both', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src={logo} alt="Logo" style={{ width: 160, height: 140, objectFit: 'contain', animation: 'pulse 1.5s infinite', marginBottom: '1.2rem' }} />
          <h1 className="syne" style={{ fontSize: 'clamp(1rem, 7vw, 5.6rem)', fontWeight: 'bolder', lineHeight: 2.08, letterSpacing: '-0.02em', marginBottom: '0.85rem' }}>
            <span className="gradient-text-amber">Agriculture</span>
          </h1>
          <p style={{ fontSize: 'clamp(15px, 2vw, 18px)', color: 'rgba(255,255,255,0.55)', maxWidth: 540, lineHeight: 1.65, fontWeight: 300 }}>
            TUMAINI LETU ASBL accompagne les producteurs locaux de Goma et de la RDC vers une agriculture durable, résiliente et inclusive pour tous.
          </p>
        </div>

        <div style={{ width: 48, height: 2, background: 'linear-gradient(90deg, transparent, #d97706, transparent)', margin: '2rem auto', animation: 'heroFadeUp 0.7s ease 0.35s both' }} />

        {/* Stat cards */}
        {/* <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 14, width: '100%', maxWidth: 700, marginBottom: '2rem' }}>
          {stats.map(s => <StatCard key={s.label} {...s} />)}
        </div> */}

        {/* Action buttons */}
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '0.75rem', animation: 'heroFadeUp 0.7s ease 1s both' }}>
          {[
            { label: 'Rejoindre le programme', bg: '#d97706', color: '#fff', border: 'none' },
            { label: 'Nos projets', bg: 'rgba(255,255,255,0.07)', color: '#fff', border: '1px solid rgba(255,255,255,0.25)' },
            { label: 'Faire un don', bg: '#fff', color: '#d97706', border: 'none' },
            { label: 'Nous contacter', bg: 'rgba(255,255,255,0.07)', color: '#fff', border: '1px solid rgba(255,255,255,0.25)' },
          ].map(b => (
            <RippleButton key={b.label} style={{
              padding: '0.7rem 1.4rem', borderRadius: 12,
              background: b.bg, color: b.color, border: b.border,
              fontSize: 14, fontWeight: 500, fontFamily: 'DM Sans, sans-serif',
              backdropFilter: 'blur(10px)', transition: 'all 0.25s ease',
            }}
              onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
            >{b.label}</RippleButton>
          ))}
        </div>

        {/* Scroll hint */}
        <div style={{ marginTop: '3rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.4rem', opacity: 0.35, animation: 'heroFadeUp 0.7s ease 1.2s both' }}>
          <span style={{ fontSize: 10, letterSpacing: '0.2em', fontFamily: 'Syne, sans-serif' }}>DÉFILER</span>
          <div style={{ width: 1, height: 36, background: 'rgba(255,255,255,0.4)', animation: 'floatY 2s ease-in-out infinite' }} />
        </div>
      </div>
    </header>
  );
};

/* ============================================================
   SECTION HEADING
   ============================================================ */
const SectionHeading = ({ badge, title, subtitle, light = false }) => (
  <div style={{ textAlign: 'center', marginBottom: '3rem' }} data-aos="fade-up">
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: '0.4rem',
      padding: '0.4rem 1rem', borderRadius: 99,
      background: light ? 'rgba(217,119,6,0.18)' : 'rgba(217,119,6,0.08)',
      border: `1px solid ${light ? 'rgba(217,119,6,0.35)' : 'rgba(217,119,6,0.18)'}`,
      fontSize: 12, fontWeight: 600,
      color: light ? '#fbbf24' : '#d97706',
      fontFamily: 'Syne, sans-serif', letterSpacing: '0.06em',
      marginBottom: '1rem',
    }}>{badge}</span>
    <h2 className="syne" style={{
      fontSize: 'clamp(1.6rem, 3vw, 2.6rem)', fontWeight: 800,
      color: light ? '#fff' : '#1a1208', lineHeight: 1.15, marginBottom: '1rem',
      letterSpacing: '-0.02em',
    }}>{title}</h2>
    {subtitle && (
      <p style={{ color: light ? 'rgba(255,255,255,0.5)' : '#5c3d11', maxWidth: 560, margin: '0 auto', lineHeight: 1.7, fontSize: 15 }}>{subtitle}</p>
    )}
  </div>
);

/* ============================================================
   INTERVENTION CARD
   ============================================================ */
const InterventionCard = ({ Icon, color, title, desc, index }) => (
  <div className="hover-lift" style={{
    display: 'flex', gap: '1rem', alignItems: 'flex-start',
    background: '#fff',
    borderRadius: 16,
    border: '1px solid rgba(217,119,6,0.08)',
    padding: '1.25rem',
    position: 'relative', overflow: 'hidden',
    animation: `cardIn 0.6s cubic-bezier(0.34,1.3,0.64,1) ${index * 0.08}s both`,
  }} data-aos="fade-up">
    <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 4, background: color, borderRadius: '16px 0 0 16px' }} />
    <div style={{
      width: 48, height: 48, borderRadius: 12, flexShrink: 0,
      background: color + '15', border: `1px solid ${color}25`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <Icon size={22} color={color} />
    </div>
    <div>
      <h3 className="syne" style={{ fontSize: 15, fontWeight: 700, color: '#1a1208', marginBottom: '0.35rem' }}>{title}</h3>
      <p style={{ fontSize: 13, color: '#7a5c2e', lineHeight: 1.7 }}>{desc}</p>
    </div>
  </div>
);

/* ============================================================
   IMPACT METRIC
   ============================================================ */
const ImpactMetric = ({ value, label, color, Icon, delay }) => (
  <div style={{
    textAlign: 'center', padding: '2rem 1rem',
    animation: `cardIn 0.7s ease ${delay}s both`,
  }} data-aos="fade-up">
    <div style={{
      width: 100, height: 100, borderRadius: '50%', margin: '0 auto 1rem',
      background: `conic-gradient(${color} 0%, ${color} 75%, rgba(255,255,255,0.08) 75%)`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      position: 'relative',
      boxShadow: `0 0 0 6px ${color}20`,
    }}>
      <div style={{
        width: 76, height: 76, borderRadius: '50%',
        background: 'rgba(255,255,255,0.04)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <Icon size={32} color={color} />
      </div>
    </div>
    <p className="syne" style={{ fontSize: 28, fontWeight: 800, color: '#fff', marginBottom: '0.3rem' }}>{value}</p>
    <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', maxWidth: 120, margin: '0 auto', lineHeight: 1.5 }}>{label}</p>
  </div>
);

/* ============================================================
   TIMELINE STEP
   ============================================================ */
const TimelineStep = ({ num, title, desc, color, Icon, isLast }) => (
  <div style={{ display: 'flex', gap: '1.25rem', position: 'relative', paddingBottom: isLast ? 0 : '2rem' }} data-aos="fade-left">
    {!isLast && <div style={{ position: 'absolute', left: 24, top: 52, bottom: 0, width: 2, background: `linear-gradient(to bottom, ${color}60, transparent)` }} />}
    <div style={{
      width: 48, height: 48, borderRadius: '50%', flexShrink: 0, zIndex: 1,
      background: color, display: 'flex', alignItems: 'center', justifyContent: 'center',
      boxShadow: `0 4px 20px ${color}50`,
    }}>
      <Icon size={20} color="#fff" />
    </div>
    <div style={{ paddingTop: '0.5rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.35rem' }}>
        <span style={{ fontSize: 10, fontWeight: 800, color: color, fontFamily: 'Syne, sans-serif', letterSpacing: '0.1em' }}>ÉTAPE {num}</span>
      </div>
      <h3 className="syne" style={{ fontSize: 16, fontWeight: 700, color: '#1a1208', marginBottom: '0.4rem' }}>{title}</h3>
      <p style={{ fontSize: 13, color: '#7a5c2e', lineHeight: 1.7 }}>{desc}</p>
    </div>
  </div>
);

/* ============================================================
   BENEFICIARY CARD
   ============================================================ */
const BeneficiaryCard = ({ Icon, iconBg, title, count, desc }) => (
  <div className="hover-lift" style={{
    borderRadius: 20, overflow: 'hidden',
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)',
    padding: '1.75rem', position: 'relative',
    textAlign: 'center',
  }} data-aos="fade-up">
    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: iconBg }} />
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: 40, marginBottom: '0.75rem',
      animation: 'harvest 3s ease-in-out infinite',
    }}>
      <Icon size={40} color={iconBg} />
    </div>
    <p className="syne" style={{ fontSize: 26, fontWeight: 800, color: '#fbbf24', marginBottom: '0.25rem' }}>{count}</p>
    <h3 className="syne" style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: '0.5rem' }}>{title}</h3>
    <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)', lineHeight: 1.65 }}>{desc}</p>
  </div>
);

/* ============================================================
   MAIN AGRICULTURE PAGE
   ============================================================ */
const Agriculture = () => {
  const [loading, setLoading] = useState(true);
  const [openFaq, setOpenFaq] = useState(null);
  const [activeFilter, setActiveFilter] = useState('tous');

  useEffect(() => {
    AOS.init({ duration: 800, once: true, offset: 60 });
    const t = setTimeout(() => setLoading(false), 1400);
    return () => clearTimeout(t);
  }, []);

  const interventions = [
    { Icon: MdSchool, color: '#d97706', title: 'Formations techniques', desc: "Apprentissage de l'agroécologie, de la permaculture et de la gestion des sols pour des rendements durables.", category: 'formation' },
    { Icon: GiSeedling, color: '#16a34a', title: 'Intrants de qualité', desc: 'Distribution de semences améliorées, résistantes au climat, et d\'outils adaptés aux réalités locales.', category: 'production' },
    { Icon: FaHandshake, color: '#b45309', title: 'Coopératives agricoles', desc: 'Structuration des producteurs pour mutualiser les coûts, accéder aux marchés et obtenir de meilleurs prix.', category: 'organisation' },
    { Icon: MdAttachMoney, color: '#d97706', title: 'Microfinance rurale', desc: 'Accès aux microcrédits ruraux pour financer les campagnes agricoles et investir dans les équipements.', category: 'financement' },
    { Icon: GiCow, color: '#92400e', title: 'Élevage diversifié', desc: 'Introduction du petit élevage avec géniteurs et soins vétérinaires pour diversifier les sources de revenus.', category: 'production' },
    { Icon: GiForest, color: '#16a34a', title: 'Agroforesterie', desc: 'Projets combinant arbres et cultures pour protéger les sols, séquestrer le carbone et améliorer la biodiversité.', category: 'production' },
    { Icon: FaFemale, color: '#d97706', title: 'Autonomisation des femmes', desc: 'Appui spécifique aux groupements de femmes et de jeunes agriculteurs pour un développement inclusif.', category: 'social' },
    { Icon: MdGavel, color: '#b45309', title: 'Accès à la terre', desc: 'Défense des droits des petits exploitants face aux conflits fonciers et accompagnement juridique.', category: 'social' },
    { Icon: RiGovernmentFill, color: '#d97706', title: 'Politiques agricoles', desc: 'Lobbying auprès des gouvernements pour obtenir des budgets d\'appui à l\'agriculture familiale en RDC.', category: 'plaidoyer' },
  ];

  const filters = [
    { id: 'tous', label: 'Tout voir' },
    { id: 'formation', label: 'Formation' },
    { id: 'production', label: 'Production' },
    { id: 'organisation', label: 'Organisation' },
    { id: 'social', label: 'Social' },
    { id: 'financement', label: 'Financement' },
    { id: 'plaidoyer', label: 'Plaidoyer' },
  ];

  const filteredInterventions = activeFilter === 'tous' ? interventions : interventions.filter(i => i.category === activeFilter);

  const timelineSteps = [
    { num: '01', Icon: IoMap, color: '#d97706', title: 'Diagnostic de terrain', desc: 'Évaluation des besoins agricoles locaux, des sols et des pratiques existantes dans la communauté cible.' },
    { num: '02', Icon: MdSchool, color: '#f59e0b', title: 'Formation des producteurs', desc: 'Sessions pratiques d\'agroécologie, permaculture et gestion durable des ressources naturelles.' },
    { num: '03', Icon: RiPlantFill, color: '#16a34a', title: 'Distribution des intrants', desc: 'Fourniture de semences améliorées, d\'outils et d\'équipements adaptés aux besoins identifiés.' },
    { num: '04', Icon: RiTeamFill, color: '#b45309', title: 'Structuration en coopérative', desc: 'Organisation des producteurs en groupements pour faciliter l\'accès aux marchés et aux financements.' },
    { num: '05', Icon: BsGraphUpArrow, color: '#d97706', title: 'Suivi & Évaluation', desc: 'Accompagnement continu des groupements et mesure des impacts socio-économiques des interventions.' },
  ];

  const faqs = [
    { q: "Comment rejoindre un programme de formation agricole ?", a: "Contactez notre bureau local à Goma ou remplissez le formulaire en ligne. Nous organisons des sessions d'inscription deux fois par an pour les nouvelles cohortes." },
    { q: "Quels types de semences distribuez-vous ?", a: "Nous distribuons des semences maraîchères, céréalières et légumineuses, toutes sélectionnées pour leur résistance aux variations climatiques de la région de Goma." },
    { q: "Comment fonctionne le système de microfinance ?", a: "En partenariat avec des institutions de microfinance locales, nous facilitons l'accès à des crédits agricoles à taux réduit, remboursables après la récolte." },
    { q: "Les femmes peuvent-elles participer aux programmes ?", a: "Absolument. Nous avons un quota minimum de 40% de femmes dans tous nos programmes et des formations spécifiquement dédiées aux groupements féminins." },
    { q: "Comment créer une coopérative avec votre aide ?", a: "Nous accompagnons les groupements de 15 producteurs minimum dans toutes les démarches légales, la formation en gestion et la mise en relation avec les marchés d'acheteurs." },
  ];

  /* ── WHY FAMILY AGRICULTURE cards ── */
  const whyCards = [
    { Icon: MdSecurity, color: '#d97706', bg: '#fef3c7', title: 'Sécurité alimentaire', desc: '80% de la production alimentaire en RDC provient des petits exploitants. Soutenir l\'agriculture familiale, c\'est nourrir le pays.' },
    { Icon: IoLeaf, color: '#16a34a', bg: '#dcfce7', title: 'Résilience climatique', desc: 'Face aux chocs climatiques, l\'agroécologie et la diversification des cultures offrent une meilleure résistance aux aléas.' },
    { Icon: MdTrendingUp, color: '#b45309', bg: '#fef9ee', title: 'Emploi rural', desc: 'Le secteur agricole emploie 70% de la population active de la RDC. Moderniser l\'agriculture, c\'est créer des emplois dignement.' },
    { Icon: IoEarth, color: '#d97706', bg: '#fef3c7', title: 'Souveraineté alimentaire', desc: 'Produire local réduit la dépendance aux importations et renforce l\'économie nationale des territoires vulnérables.' },
    { Icon: FaFemale, color: '#92400e', bg: '#fef9ee', title: 'Justice de genre', desc: 'Les femmes produisent 60% des cultures vivrières mais détiennent peu de terre. Nos programmes corrigent ce déséquilibre.' },
    { Icon: TbMicroscope, color: '#16a34a', bg: '#dcfce7', title: 'Innovation agro', desc: 'L\'agroécologie allie savoirs ancestraux et techniques modernes pour une agriculture productive et respectueuse des sols.' },
  ];

  /* ── TESTIMONIALS ── */
  const testimonials = [
    { name: 'Mama Esperance NZOVU', role: 'Présidente de coopérative', text: "Grâce à la formation en agroécologie et aux semences améliorées, ma coopérative a triplé sa production de haricots. Aujourd'hui je vends au marché de Goma chaque semaine.", Icon: GiFarmer, accent: '#d97706' },
    { name: 'Pascal MUHINDO', role: 'Jeune agriculteur, 24 ans', text: "Le microcrédit m'a permis d'acheter une pompe à eau. Maintenant j'irrigue mon champ toute l'année et je n'attends plus la saison des pluies pour cultiver.", Icon: GiFarmer, accent: '#f59e0b' },
    { name: 'Sœur Marie-Claire', role: 'Partenaire éducative', text: "Les ateliers de TUMAINI LETU dans nos villages ont changé la mentalité des jeunes sur l'agriculture. C'est devenu une voie d'avenir, plus une fatalité.", Icon: MdSchool, accent: '#16a34a' },
  ];

  return (
    <div style={{ fontFamily: 'DM Sans, sans-serif', background: '#faf6f0', color: '#1a1208', overflowX: 'hidden' }}>
      <GlobalStyles />
      <PageLoader loading={loading} />
      <Navbar />

      {/* ── HERO ── */}
      <Hero video={bgVideo} />

      {/* ── MISSION STRIP ── */}
      <section style={{ background: 'linear-gradient(135deg, #d97706 0%, #b45309 100%)', padding: '2.5rem 1.25rem' }}>
        <div style={{ maxWidth: 1140, margin: '0 auto', display: 'flex', flexWrap: 'wrap', gap: '2rem', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ flex: 1, minWidth: 260 }}>
            <h2 className="syne" style={{ fontSize: 'clamp(1.2rem, 2.5vw, 1.7rem)', fontWeight: 800, color: '#fff', marginBottom: '0.5rem' }}>
              Sécurité alimentaire pour la RDC
            </h2>
            <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.75)', lineHeight: 1.65, maxWidth: 480 }}>
              Dans la région de Goma, TUMAINI LETU ASBL joue un rôle essentiel en accompagnant les producteurs locaux vers une agriculture familiale résiliente et durable.
            </p>
          </div>
          <div style={{ display: 'flex', gap: '2.5rem', flexWrap: 'wrap' }}>
            {[
              ['Goma', 'Zone principale', FiMapPin],
              ['RDC', 'Couverture nationale', IoEarth],
              ['2018', 'Depuis', BsFillStarFill],
            ].map(([v, l, Ic]) => (
              <div key={l} style={{ textAlign: 'center' }}>
                <p className="syne" style={{ fontSize: 24, fontWeight: 800, color: '#fff' }}>{v}</p>
                <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)', letterSpacing: '0.06em' }}>{l}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── INTERVENTIONS ── */}
      <section style={{ padding: '5rem 1.25rem', background: '#faf6f0', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: 0, right: 0, width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle, rgba(217,119,6,0.07), transparent)', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', bottom: 0, left: 0, width: 350, height: 350, borderRadius: '50%', background: 'radial-gradient(circle, rgba(22,163,74,0.05), transparent)', pointerEvents: 'none' }} />
        <div className="hex-pattern" style={{ position: 'absolute', inset: 0, opacity: 1, pointerEvents: 'none' }} />

        <div style={{ position: 'relative', zIndex: 1, maxWidth: 1140, margin: '0 auto' }}>
          <SectionHeading
            badge={<><GiWheat size={13} /> INTERVENTIONS</>}
            title="Nos domaines d'intervention"
            subtitle="Des actions ciblées et concrètes pour transformer l'agriculture familiale en RDC."
          />

          {/* Filter tabs */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', justifyContent: 'center', marginBottom: '2.5rem' }} data-aos="fade-up">
            {filters.map(f => (
              <button key={f.id} onClick={() => setActiveFilter(f.id)} style={{
                padding: '0.4rem 1rem', borderRadius: 99, border: 'none', cursor: 'pointer',
                fontFamily: 'Syne, sans-serif', fontWeight: 600, fontSize: 12,
                transition: 'all 0.2s',
                background: activeFilter === f.id ? '#d97706' : 'rgba(217,119,6,0.08)',
                color: activeFilter === f.id ? '#fff' : '#d97706',
                boxShadow: activeFilter === f.id ? '0 4px 14px rgba(217,119,6,0.3)' : 'none',
              }}>{f.label}</button>
            ))}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
            {filteredInterventions.map((item, i) => (
              <InterventionCard key={item.title} {...item} index={i} />
            ))}
          </div>
        </div>
      </section>

      {/* ── NOTRE APPROCHE (Timeline) ── */}
      <section style={{ padding: '5rem 1.25rem', background: '#fff', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, width: '40%', background: 'linear-gradient(135deg, rgba(217,119,6,0.03), transparent)', pointerEvents: 'none' }} />
        <div style={{ position: 'relative', zIndex: 1, maxWidth: 1140, margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem', alignItems: 'center' }}>
            <div data-aos="fade-right">
              <SectionHeading
                badge="APPROCHE"
                title="Notre méthode terrain"
                subtitle="Un processus structuré, de l'écoute au terrain, pour un impact durable."
              />
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {timelineSteps.map((step, i) => (
                  <TimelineStep key={step.num} {...step} isLast={i === timelineSteps.length - 1} />
                ))}
              </div>
            </div>

            <div data-aos="fade-left" style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
              {/* Visual stats panel */}
              <div style={{
                borderRadius: 24, overflow: 'hidden',
                background: 'linear-gradient(135deg, #1a0e04, #2d1a08)',
                padding: '2rem',
              }}>
                <p className="syne" style={{ fontSize: 13, color: 'rgba(251,191,36,0.7)', letterSpacing: '0.1em', marginBottom: '1.5rem' }}>INDICATEURS DE PERFORMANCE 2024</p>
                {[
                  { label: "Taux d'adoption des pratiques agroécologiques", pct: 78, color: '#d97706' },
                  { label: 'Augmentation des rendements agricoles', pct: 65, color: '#f59e0b' },
                  { label: 'Accès aux marchés formels', pct: 52, color: '#16a34a' },
                  { label: 'Satisfaction des bénéficiaires', pct: 91, color: '#fbbf24' },
                ].map(({ label, pct, color }) => (
                  <div key={label} style={{ marginBottom: '1.1rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.4rem' }}>
                      <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', lineHeight: 1.4 }}>{label}</p>
                      <span className="syne" style={{ fontSize: 14, fontWeight: 700, color, flexShrink: 0, marginLeft: '0.5rem' }}>{pct}%</span>
                    </div>
                    <div className="progress-bar">
                      <div className="progress-fill" style={{ width: `${pct}%`, background: `linear-gradient(90deg, ${color}80, ${color})` }} />
                    </div>
                  </div>
                ))}
              </div>

              {/* Quote block */}
              <div style={{
                borderRadius: 20,
                background: 'rgba(217,119,6,0.06)',
                border: '1px solid rgba(217,119,6,0.15)',
                padding: '1.5rem',
                position: 'relative',
              }}>
                <div style={{ fontSize: 36, color: '#d97706', opacity: 0.3, lineHeight: 1, marginBottom: '0.5rem', fontFamily: 'serif' }}>"</div>
                <p style={{ fontSize: 14, color: '#5c3d11', lineHeight: 1.8, fontStyle: 'italic', marginBottom: '1rem' }}>
                  L'agroécologie n'est pas qu'une technique, c'est une philosophie qui réconcilie l'homme avec la terre. Nous aidons les familles à cultiver leur dignité en même temps que leur champ.
                </p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg, #d97706, #f59e0b)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <GiFarmer size={18} color="#fff" />
                  </div>
                  <div>
                    <p style={{ fontSize: 13, fontWeight: 700, color: '#1a1208', fontFamily: 'Syne, sans-serif' }}>Directrice des Programmes</p>
                    <p style={{ fontSize: 11, color: '#d97706' }}>TUMAINI LETU ASBL</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── BÉNÉFICIAIRES ── */}
      <section style={{ padding: '5rem 1.25rem', background: '#120a02', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: 600, height: 300, borderRadius: '50%', background: 'rgba(217,119,6,0.08)', filter: 'blur(80px)', pointerEvents: 'none' }} />
        <div style={{ position: 'relative', zIndex: 1, maxWidth: 1140, margin: '0 auto' }}>
          <SectionHeading light badge={<><FaHandshake size={13} /> BÉNÉFICIAIRES</>} title="Qui bénéficie de nos programmes ?" subtitle="Des communautés rurales aux femmes entrepreneures, nos programmes touchent tous les acteurs agricoles." />

          {/* Impact metrics */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '1rem', marginBottom: '3rem' }}>
            <ImpactMetric value="2,800+" label="Agriculteurs formés" color="#d97706" Icon={GiFarmer} delay={0.1} />
            <ImpactMetric value="960+" label="Femmes soutenues" color="#f59e0b" Icon={FaFemale} delay={0.2} />
            <ImpactMetric value="34" label="Coopératives actives" color="#16a34a" Icon={FaHandshake} delay={0.3} />
            <ImpactMetric value="5,200+" label="Hectares cultivés" color="#b45309" Icon={GiWheat} delay={0.4} />
            <ImpactMetric value="12,000+" label="Familles impactées" color="#fbbf24" Icon={FaHome} delay={0.5} />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 18 }}>
            <BeneficiaryCard Icon={BsPeopleFill} iconBg="#d97706" title="Familles rurales" count="12,000+" desc="Ménages paysans de Goma et ses environs bénéficiant de formations, d'intrants et d'un accès aux marchés." />
            <BeneficiaryCard Icon={FaFemale} iconBg="#f59e0b" title="Groupements féminins" count="64 groupes" desc="Femmes agricultrices organisées en coopératives pour accéder au microcrédit et à la commercialisation." />
            <BeneficiaryCard Icon={FaChild} iconBg="#16a34a" title="Jeunes agriculteurs" count="1,200+" desc="Jeunes ruraux formés à l'agroécologie pour prendre la relève et moderniser l'agriculture familiale." />
            <BeneficiaryCard Icon={GiForest} iconBg="#b45309" title="Zones agroforestières" count="28 sites" desc="Territoires où agroforesterie et cultures vivrières sont combinés pour restaurer les écosystèmes." />
          </div>
        </div>
      </section>

      {/* ── POURQUOI L'AGRICULTURE FAMILIALE ── */}
      <section style={{ padding: '5rem 1.25rem', background: '#faf6f0', position: 'relative', overflow: 'hidden' }}>
        <div className="hex-pattern" style={{ position: 'absolute', inset: 0, opacity: 0.6, pointerEvents: 'none' }} />
        <div style={{ position: 'relative', zIndex: 1, maxWidth: 1140, margin: '0 auto' }}>
          <SectionHeading badge="ENJEUX" title="Pourquoi l'agriculture familiale ?" subtitle="À Goma et en RDC, l'agriculture familiale est le pilier de la sécurité alimentaire et du développement local." />

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20 }}>
            {whyCards.map((c, i) => (
              <div key={c.title} className="hover-lift" style={{
                borderRadius: 20, background: '#fff',
                border: '1px solid rgba(217,119,6,0.08)',
                padding: '1.5rem',
                animation: `cardIn 0.6s ease ${i * 0.07}s both`,
              }} data-aos="fade-up">
                <div style={{
                  width: 52, height: 52, borderRadius: 16,
                  background: c.bg, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  marginBottom: '1rem',
                  border: `1px solid ${c.color}20`,
                }}>
                  <c.Icon size={24} color={c.color} />
                </div>
                <h3 className="syne" style={{ fontSize: 16, fontWeight: 700, color: '#1a1208', marginBottom: '0.5rem' }}>{c.title}</h3>
                <p style={{ fontSize: 13, color: '#7a5c2e', lineHeight: 1.7 }}>{c.desc}</p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div style={{
            marginTop: '3rem', borderRadius: 24, overflow: 'hidden',
            background: 'linear-gradient(135deg, #92400e 0%, #d97706 60%, #f59e0b 100%)',
            padding: '3rem 2.5rem', position: 'relative', textAlign: 'center',
          }} data-aos="fade-up">
            <div style={{ position: 'absolute', top: -60, right: -60, width: 220, height: 220, borderRadius: '50%', background: 'rgba(255,255,255,0.07)', filter: 'blur(40px)', pointerEvents: 'none' }} />
            <div style={{ position: 'absolute', bottom: -40, left: -40, width: 180, height: 180, borderRadius: '50%', background: 'rgba(0,0,0,0.1)', filter: 'blur(30px)', pointerEvents: 'none' }} />
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem', animation: 'harvest 2.5s ease-in-out infinite' }}>
                <GiWheat size={44} color="rgba(255,255,255,0.9)" />
              </div>
              <h3 className="syne" style={{ fontSize: 'clamp(1.3rem, 2.5vw, 2.2rem)', fontWeight: 800, color: '#fff', marginBottom: '0.75rem' }}>
                Cultivons l'avenir ensemble
              </h3>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14, maxWidth: 520, margin: '0 auto 1.75rem', lineHeight: 1.7 }}>
                Rejoignez TUMAINI LETU ASBL dans sa mission de transformer l'agriculture familiale au Congo pour une sécurité alimentaire durable.
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '0.75rem' }}>
                <RippleButton style={{ padding: '0.8rem 1.75rem', borderRadius: 12, background: '#fff', color: '#d97706', fontSize: 14, fontWeight: 700, display: 'flex', alignItems: 'center', gap: '0.4rem' }} onClick={() => window.location.href = "mailto:info@tumainiletu.com"}>
                  <FaHandshake size={15} /> Devenir partenaire
                </RippleButton>
                <RippleButton style={{ padding: '0.8rem 1.75rem', borderRadius: 12, background: 'rgba(0,0,0,0.2)', color: '#fff', border: '1px solid rgba(255,255,255,0.3)', fontSize: 14, fontWeight: 600 }}>
                  Voir nos projets
                </RippleButton>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── TÉMOIGNAGES ── */}
      <section style={{ padding: '5rem 1.25rem', background: '#fff', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'relative', zIndex: 1, maxWidth: 1140, margin: '0 auto' }}>
          <SectionHeading badge="TÉMOIGNAGES" title="Voix du terrain" subtitle="Ce que disent les agriculteurs et partenaires qui vivent nos programmes au quotidien." />
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 20 }}>
            {testimonials.map((t, i) => (
              <div key={t.name} className="hover-lift" style={{
                borderRadius: 20,
                background: '#faf6f0',
                border: '1px solid rgba(217,119,6,0.08)',
                padding: '1.75rem', position: 'relative', overflow: 'hidden',
                animation: `cardIn 0.7s ease ${i * 0.12}s both`,
              }} data-aos="fade-up">
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: `linear-gradient(90deg, ${t.accent}, ${t.accent}60)` }} />
                <div style={{ fontSize: 32, color: t.accent, opacity: 0.35, lineHeight: 1, marginBottom: '0.65rem', fontFamily: 'Georgia, serif' }}>"</div>
                <p style={{ fontSize: 14, color: '#5c3d11', lineHeight: 1.8, marginBottom: '1.25rem', fontStyle: 'italic' }}>{t.text}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <div style={{ width: 44, height: 44, borderRadius: '50%', background: `linear-gradient(135deg, ${t.accent}, ${t.accent}80)`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <t.Icon size={20} color="#fff" />
                  </div>
                  <div>
                    <p style={{ fontSize: 13, fontWeight: 700, color: '#1a1208', fontFamily: 'Syne, sans-serif' }}>{t.name}</p>
                    <p style={{ fontSize: 11, color: t.accent }}>{t.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CONTACT ── */}
      <section style={{ maxWidth: 800, margin: '0 auto', padding: '4rem 1.25rem' }} data-aos="fade-up">
        <SectionHeading badge="CONTACT" title="Rejoignez le programme" />
        <div style={{ background: '#fff', borderRadius: 24, padding: '2rem', border: '1px solid rgba(217,119,6,0.1)', borderTop: '4px solid #d97706' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.75rem' }}>
            {[{ ph: 'Nom complet', type: 'text' }, { ph: 'Adresse email', type: 'email' }].map(f => (
              <input key={f.ph} type={f.type} placeholder={f.ph} style={{
                padding: '0.85rem 1rem', borderRadius: 12,
                border: '1px solid rgba(217,119,6,0.15)',
                background: '#fef9ee', fontSize: 14, color: '#1a1208',
                outline: 'none', fontFamily: 'DM Sans, sans-serif', transition: 'border-color 0.2s',
              }}
                onFocus={e => e.target.style.borderColor = '#d97706'}
                onBlur={e => e.target.style.borderColor = 'rgba(217,119,6,0.15)'}
              />
            ))}
            <input type="tel" placeholder="Téléphone" style={{
              padding: '0.85rem 1rem', borderRadius: 12,
              border: '1px solid rgba(217,119,6,0.15)', gridColumn: '1/-1',
              background: '#fef9ee', fontSize: 14, color: '#1a1208',
              outline: 'none', fontFamily: 'DM Sans, sans-serif', transition: 'border-color 0.2s',
            }}
              onFocus={e => e.target.style.borderColor = '#d97706'}
              onBlur={e => e.target.style.borderColor = 'rgba(217,119,6,0.15)'}
            />
            <select style={{
              padding: '0.85rem 1rem', borderRadius: 12, gridColumn: '1/-1',
              border: '1px solid rgba(217,119,6,0.15)',
              background: '#fef9ee', fontSize: 14, color: '#7a5c2e',
              outline: 'none', fontFamily: 'DM Sans, sans-serif', cursor: 'pointer',
            }}>
              <option value="">Je souhaite... (choisir)</option>
              <option value="formation">Participer à une formation agricole</option>
              <option value="cooperative">Créer ou rejoindre une coopérative</option>
              <option value="microcredit">Accéder au microcrédit agricole</option>
              <option value="partenariat">Proposer un partenariat</option>
              <option value="don">Faire un don ou du mécénat</option>
            </select>
            <textarea rows={4} placeholder="Dites-nous comment vous souhaitez contribuer ou quelle aide vous recherchez..." style={{
              padding: '0.85rem 1rem', borderRadius: 12, gridColumn: '1/-1',
              border: '1px solid rgba(217,119,6,0.15)',
              background: '#fef9ee', fontSize: 14, color: '#1a1208', resize: 'none',
              outline: 'none', fontFamily: 'DM Sans, sans-serif', transition: 'border-color 0.2s',
            }}
              onFocus={e => e.target.style.borderColor = '#d97706'}
              onBlur={e => e.target.style.borderColor = 'rgba(217,119,6,0.15)'}
            />
          </div>
          <div style={{ textAlign: 'center', marginTop: '1.25rem' }}>
            <RippleButton style={{ padding: '0.8rem 2.25rem', borderRadius: 12, background: 'linear-gradient(135deg, #d97706, #b45309)', color: '#fff', fontSize: 14, fontWeight: 600, boxShadow: '0 4px 20px rgba(217,119,6,0.3)', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
              <FiMail size={15} /> Envoyer ma demande
            </RippleButton>
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section style={{ position: 'relative', padding: '4rem 1.25rem 5rem', background: '#fef9ee', overflow: 'hidden' }}>
        <div style={{ position: 'relative', zIndex: 1, maxWidth: 760, margin: '0 auto' }}>
          <SectionHeading badge={<><AiOutlineQuestionCircle size={13} /> FAQ</>} title="Questions fréquentes" subtitle="Tout ce que vous devez savoir sur nos programmes d'agriculture familiale." />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            {faqs.map((item, i) => (
              <div key={i} onClick={() => setOpenFaq(openFaq === i ? null : i)} style={{
                background: '#fff', borderRadius: 14, overflow: 'hidden',
                border: `1px solid ${openFaq === i ? 'rgba(217,119,6,0.3)' : 'rgba(217,119,6,0.1)'}`,
                cursor: 'pointer', transition: 'border-color 0.25s',
                boxShadow: openFaq === i ? '0 4px 20px rgba(217,119,6,0.08)' : 'none',
              }} data-aos="fade-up">
                <div style={{ padding: '1.1rem 1.25rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem' }}>
                  <p style={{ fontSize: 14, fontWeight: 600, color: '#1a1208', fontFamily: 'Syne, sans-serif' }}>{item.q}</p>
                  <div style={{
                    width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
                    background: openFaq === i ? '#d97706' : 'rgba(217,119,6,0.1)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: openFaq === i ? '#fff' : '#d97706',
                    transition: 'all 0.3s',
                    transform: openFaq === i ? 'rotate(45deg)' : 'none',
                    fontSize: 16,
                  }}>+</div>
                </div>
                <div style={{ maxHeight: openFaq === i ? 200 : 0, overflow: 'hidden', transition: 'max-height 0.4s cubic-bezier(0.4,0,0.2,1)' }}>
                  <p style={{ padding: '0 1.25rem 1.1rem', fontSize: 13, color: '#7a5c2e', lineHeight: 1.75 }}>{item.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SUPPORT ── */}
      <section style={{ background: '#faf6f0', padding: '3rem 1.25rem', textAlign: 'center' }} data-aos="fade-up">
        <div style={{ maxWidth: 500, margin: '0 auto' }}>
          <h2 className="syne" style={{ fontSize: 22, fontWeight: 700, marginBottom: '0.6rem' }}>Besoin d'informations ?</h2>
          <p style={{ fontSize: 14, color: '#7a5c2e', marginBottom: '1.25rem', lineHeight: 1.7 }}>Contactez notre équipe agriculture pour tout renseignement sur nos programmes ou partenariats.</p>
          <RippleButton
            style={{ padding: '0.75rem 1.75rem', borderRadius: 12, background: '#d97706', color: '#fff', fontSize: 14, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}
            onClick={() => window.location.href = "mailto:agriculture@tumainiletu.com?subject=Question%20Agriculture"}
          >
            <MdEmail size={16} /> Contacter l'équipe
          </RippleButton>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Agriculture;
